export const searchRoute = ({ lat, lng, text }) => {
	return `https://api.neshan.org/v1/search?term=${text}&lat=${lat}&lng=${lng}`
}

export const routingRoute = ({ originLat, originLng, destLat, destLng }) => {
	return `https://api.neshan.org/v3/direction?type=car&origin=${originLat},${originLng}&destination=${destLat},${destLng}&avoidTrafficZone=false&avoidOddEvenZone=false`
}
